<template>
    <div class="app-container">
      <list ref="list">
        <template slot="toolbar-right">
         
        </template>
       
      </list>
     
    </div>
  </template>
  <script>
  import curdMixins from "@/mixins/curd";
  import list from "@/components/wh/summary/list";

  
  export default {
    name: "whsummarybook",
    mixins: [curdMixins],
    components: {
      list,
     
    },
    methods: {
            
    },
  };
  </script>